import { render } from "./CustomObjects.vue?vue&type=template&id=561a4edd&scoped=true"
import script from "./CustomObjects.vue?vue&type=script&lang=ts"
export * from "./CustomObjects.vue?vue&type=script&lang=ts"

import "./CustomObjects.vue?vue&type=style&index=0&id=561a4edd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-561a4edd"

export default script